<template>
    <div v-if="settings.external_analytics" class="dynamic-graphs">

            <v-layout row wrap class="align-center">
                <v-flex
                  v-for="(item, index) in data"
                  :class="`md${getWidth(item.type)} pa-2`"
                >
                    <div class="card-curvey" >
                     <component :is="getComponent(item.type)" :data="item"></component>
                    </div>
                </v-flex>
            </v-layout>
        </div>

</template>

<script>
    import common from "../../../utils/common";
    import infoBox from './info-box'
    import pieChart from './pie-chart'
    import tableData from './table-data'
    import dynamicTable from './dynamic-table'
    import lineChart from './line-chart'
    import multiLineChart from './multi-line-chart'
    export default {
        name: "graphe-loader",
        components: {
            infoBox,
            pieChart,
            tableData,
            lineChart,
            dynamicTable,
            multiLineChart
        },
        data () {
            return {
                settings: {},
                data: [],
                graphs: [
                    {
                        name: 'info-box',
                        value: 'info-box',
                        width: '3'
                    },
                    {
                        name: 'pichart',
                        value: 'pie-chart',
                        width: '6'
                    },
                    {
                        name: 'table',
                        value: 'table-data',
                        width: '12'
                    },
                    {
                        name: 'dynamic-table',
                        value: 'dynamic-table',
                        width: '12'
                    },
                    {
                        name: 'lineChart',
                        value: 'line-chart',
                        width: '12'
                    },
                    {
                        name: 'multi-line-chart',
                        value: 'multi-line-chart',
                        width: '12'
                    },
                ]
            }
        },
        mounted() {
            this.getSettings()
        },
        methods: {
            getSettings() {
                    this.$store.dispatch('setLoader', true)
                    this.$http_bot.get('/settings/')
                        .then(response => {
                            this.settings = response.data
                            if (!this.settings.nlp) {
                                this.settings.nlp = {}
                            }

                            this.getAnalytics()

                        })
                        .catch(error => {
                            this.$store.dispatch('setLoader', false)
                            if (error.response.status === 401) {
                                common.logOut()
                                this.$store.dispatch('setLoader', false)
                            }
                        })
            },
            getAnalytics() {
                if (this.settings.external_analytics) {
                    this.$http_without_base(this.settings.external_analytics)
                        .then(response => {
                            this.data = response.data;
                            console.log(this.data[0], " getAnalytics")
                            this.$store.dispatch('setLoader', false)
                            this.getSecondaryAnalytics()
                        })
                        .catch(error => {
                            this.$store.dispatch('setLoader', false)
                            if (error.response.status === 401) {
                                common.logOut()
                                this.$store.dispatch('setLoader', false)
                            }
                        })
                } else {
                    this.$store.dispatch('setLoader', false)
                }
            },
            getSecondaryAnalytics() {
                if (this.settings.external_analytics_second) {
                    this.$http_without_base(this.settings.external_analytics_second)
                      .then(response => {
                          this.data  = this.data.concat(response.data);
                          console.log(this.data, " getAnalytics")
                          this.$store.dispatch('setLoader', false)
                      })
                      .catch(error => {
                          this.$store.dispatch('setLoader', false)
                          if (error.response.status === 401) {
                              common.logOut()
                              this.$store.dispatch('setLoader', false)
                          }
                      })
                } else {
                    this.$store.dispatch('setLoader', false)
                }
            },
            getComponent (type) {
                let graphe = this.graphs.find(item=> {
                    return item.name === type
                })
                return graphe.value
            },
            getWidth (type) {
                let graphe = this.graphs.find(item=> {
                    return item.name === type
                })
                return graphe.width
            }
        }
    }
</script>

<style scoped>

</style>
